import React from 'react'

export default ({
  history,
  user
}) => (
  <div className='history-item'>
    <p className='timestamp'>
      {history.createdAt.format('MMMM Do, YYYY')} by {user.name}
    </p>

    <p>Notes: {history.description || '—'}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/histories/history-item.js